<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail"
  >
    <!-- 页面头部 Start -->
    <div class="l-page__header c-page__header">
      <!-- 页面标题 -->
      <h2 class="c-page__header-title">
        用户新增
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div class="c-page__header-btns">
        <el-button
          type="primary"
          icon="kestrel-icon ki-save"
          @click="handleSave()"
        >
          保存
        </el-button>
        <el-button
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        >
          关闭
        </el-button>
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 页面主内容：详情 Start -->
    <div class="l-page__body l-page--detail__body">
      <hm-page-card class="c-card--detail">
        <!-- 警告：用户已存在 -->
        <el-alert
          v-show="editCapacityVo"
          class="u-mg-b-8"
          :closable="false"
          type="warning"
          title="用户存在提示"
          show-icon
        >
          编码为<span class="u-text-success u-text-14">
            【{{ fd.userVO.userCode }}】
          </span>
          的用户已经存在其他组织信息，部门再新增用户，转为在<span class="u-text-success u-text-14">
            【{{ fd.capacityVO.deptName }}】
          </span>
          组织下新增身份信息。
          <el-button
            class="u-mg-l-6"
            @click="handleClickReset"
          >
            重新输入用户
          </el-button>
        </el-alert>

        <el-form
          ref="fd"
          class="c-form"
          :model="fd"
          :rules="fdRules"
          :inline="true"
          :validate-on-rule-change="false"
          label-position="right"
          label-width="118px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              用户基本信息
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="用户编码"
                prop="userVO.userCode"
              >
                <el-input
                  v-if="!editCapacityVo"
                  v-model.trim="fd.userVO.userCode"
                  class="c-form__input"
                  placeholder=""
                  @change="handleUserCodeChange"
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userVO.userCode }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="用户名称"
                prop="userVO.userName"
              >
                <el-input
                  v-if="!editCapacityVo"
                  v-model.trim="fd.userVO.userName"
                  class="c-form__input"
                  placeholder=""
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userVO.userName }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="联系电话"
                prop="userVO.tel"
              >
                <el-input
                  v-if="!editCapacityVo"
                  v-model.trim="fd.userVO.tel"
                  class="c-form__input"
                  placeholder=""
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userVO.tel }}
                </span>
              </el-form-item>
            </el-col>

            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="有效标志"
                prop="userVO.valid"
              >
                <el-radio-group
                  v-if="!editCapacityVo"
                  v-model="fd.userVO.valid"
                  class="c-form__radio-group"
                >
                  <el-radio label="Y">
                    有效
                  </el-radio>
                  <el-radio label="N">
                    无效
                  </el-radio>
                </el-radio-group>
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userVO.valid === 'Y' ? '有效' : '无效' }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="邮箱"
                prop="userVO.email"
              >
                <el-input
                  v-if="!editCapacityVo"
                  v-model.trim="fd.userVO.email"
                  class="c-form__input"
                  placeholder=""
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userVO.email }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="数据来源"
                prop="userVO.sourceType"
              >
                自建
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="是否主账号"
                prop="SFZZH"
              >
                <el-radio-group
                  v-model="SFZZH"
                  class="c-form__radio-group"
                >
                  <el-radio label="Y">
                    是
                  </el-radio>
                  <el-radio label="N">
                    否
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col
              v-for="(attrUserItem, index) in attrUserList"
              :key="'attrUser'+ index"
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                :label="attrUserItem.attrName"
                :prop="'userVO.attrs.' + attrUserItem.attrKey"
              >
                <template v-if="attrUserItem.enums">
                  <template v-if="enums[attrUserItem.enums] && Object.keys(enums[attrUserItem.enums]).length <= 2">
                    <el-radio-group
                      v-if="!editCapacityVo"
                      v-model="fd.userVO.attrs[attrUserItem.attrKey]"
                      class="c-form__radio-group"
                    >
                      <el-radio
                        v-for="value in enums[attrUserItem.enums]"
                        :key="value.id"
                        :label="value.id"
                      >
                        {{ value.text }}
                      </el-radio>
                    </el-radio-group>
                    <span
                      v-else
                      class="c-form__read"
                    >
                      {{ fd.userVO.attrs[attrUserItem.attrKey] | enums(attrUserItem.enums) }}
                    </span>
                  </template>
                  <template v-else>
                    <el-select
                      v-if="!editCapacityVo"
                      v-model="fd.userVO.attrs[attrUserItem.attrKey]"
                      class="c-form__select"
                      style="width: 100%;"
                      placeholder=""
                      clearable
                    >
                      <el-option
                        v-for="(value) in enums[attrUserItem.enums]"
                        :key="value.id"
                        :label="value.text"
                        :value="value.id"
                      />
                    </el-select>
                    <span
                      v-else
                      class="c-form__read"
                    >
                      {{ fd.userVO.attrs[attrUserItem.attrKey] | enums(attrUserItem.enums) }}
                    </span>
                  </template>
                </template>
                <template v-else-if="attrUserItem.attrType === 'String' || attrUserItem.attrType === 'Double'">
                  <el-input
                    v-if="!editCapacityVo"
                    v-model.trim="fd.userVO.attrs[attrUserItem.attrKey]"
                    class="c-form__input"
                    placeholder=""
                  />
                  <span
                    v-else
                    class="c-form__read"
                  >
                    {{ fd.userVO.attrs[attrUserItem.attrKey] }}
                  </span>
                </template>
                <template v-else-if="attrUserItem.attrType === 'Date'">
                  <el-date-picker
                    v-if="!editCapacityVo"
                    v-model.trim="fd.userVO.attrs[attrUserItem.attrKey]"
                    class="c-form__date"
                    type="date"
                    placeholder="选择日期"
                    value-format="timestamp"
                  />
                  <span
                    v-else
                    class="c-form__read"
                  >
                    {{ fd.userVO.attrs[attrUserItem.attrKey] | date('yyyy-MM-dd') }}
                  </span>
                </template>
              </el-form-item>
            </el-col>
            <!-- col空白占位填充 -->
            <el-col
              v-if="attrUserList.length%2 === 0"
              class="c-form__col c-form__placeholder"
              :span="12"
            />
            <!-- 单身份 身份的所属组织、职务（扩展字段）移动到用户部分 start -->
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="所属组织"
                prop="capacityVO.deptCode"
              >
                <hm-tree-select
                  v-if="!editCapacityVo"
                  ref="dept"
                  v-model="fd.capacityVO.deptCode"
                  class="c-tree-select-wrap"
                  instance-id="cTreeSelect"
                  placeholder="请选择所属组织"
                  :append-to-body="true"
                  :options="deptList"
                  :normalizer="normalizer"
                  :clearable="false"
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.capacityVO.deptName }}
                </span>
              </el-form-item>
            </el-col>

            <el-col
              v-for="(attrCapacityItem, index) in attrCapacityList"
              :key="'attrCapacity'+ index"
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                :label="attrCapacityItem.attrName"
                :prop="'capacityVO.attrs.' + attrCapacityItem.attrKey"
              >
                <template v-if="attrCapacityItem.enums">
                  <template v-if="Object.keys(enums[attrCapacityItem.enums]).length <= 2">
                    <el-radio-group
                      v-model="fd.capacityVO.attrs[attrCapacityItem.attrKey]"
                      class="c-form__radio-group"
                    >
                      <el-radio
                        v-for="value in enums[attrCapacityItem.enums]"
                        :key="value.id"
                        :label="value.id"
                      >
                        {{ value.text }}
                      </el-radio>
                    </el-radio-group>
                  </template>
                  <template v-else>
                    <el-select
                      v-model="fd.capacityVO.attrs[attrCapacityItem.attrKey]"
                      class="c-form__select"
                      style="width: 100%;"
                      placeholder=""
                      clearable
                    >
                      <el-option
                        v-for="(value) in enums[attrCapacityItem.enums]"
                        :key="value.id"
                        :label="value.text"
                        :value="value.id"
                      />
                    </el-select>
                  </template>
                </template>
                <template v-else-if="attrCapacityItem.attrType === 'String'">
                  <el-input
                    v-model.trim="fd.capacityVO.attrs[attrCapacityItem.attrKey]"
                    class="c-form__input"
                    placeholder=""
                  />
                </template>
                <template v-else-if="attrCapacityItem.attrType === 'Date'">
                  <el-date-picker
                    v-model.trim="fd.capacityVO.attrs[attrCapacityItem.attrKey]"
                    class="c-form__date"
                    type="date"
                    placeholder="选择日期"
                    value-format="timestamp"
                  />
                </template>
              </el-form-item>
            </el-col>
            <!-- col空白占位填充 -->
            <el-col
              v-if="attrCapacityList.length%2===0"
              class="c-form__col c-form__placeholder"
              :span="12"
            />
            <!-- 单身份 身份的所属组织、职务（扩展字段）移动到用户部分 end -->
            <el-col
              class="c-form__col c-form__part-title"
              :span="24"
            >
              用户登录账号信息
            </el-col>
            <el-col
              class="c-form__col"
              :span="editCapacityVo ? 24 : 12"
            >
              <el-form-item
                class="c-form__item"
                label="登录账号"
                prop="userAuthVO.account"
              >
                <el-input
                  v-if="!editCapacityVo"
                  v-model.trim="fd.userAuthVO.account"
                  class="c-form__input"
                  placeholder=""
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userAuthVO.account }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              v-if="!editCapacityVo"
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="登录密码"
                prop="userAuthVO.pwd"
              >
                <el-input
                  v-model.trim="fd.userAuthVO.pwd"
                  class="c-form__input"
                  placeholder=""
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="有效期起"
                prop="userAuthVO.effectStartDate"
              >
                <el-date-picker
                  v-if="!editCapacityVo"
                  v-model="fd.userAuthVO.effectStartDate"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userAuthVO.effectStartDate | date('yyyy-MM-dd') }}
                </span>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="有效期止"
                prop="userAuthVO.effectEndDate"
              >
                <el-date-picker
                  v-if="!editCapacityVo"
                  v-model="fd.userAuthVO.effectEndDate"
                  class="c-form__date"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                />
                <span
                  v-else
                  class="c-form__read"
                >
                  {{ fd.userAuthVO.effectStartDate | date('yyyy-MM-dd') }}
                </span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
  </div>
</template>

<script>
import { userService } from './user.service';
// 继承于新增用户
import AddUser from '@/features/system/attr/user/addUser.vue';
export default {
  name: 'SingleAddUser',
  extends: AddUser,
  data () {
    return {
      SFZZH: 'Y'
    };
  },
  methods: {
    /**
     * @description: 保存
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.fd.userVO.attrs.SFZZH = this.SFZZH;
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.loading = true;
          // 如果是新增用户，调用新增用户接口
          if (!this.editCapacityVo) {
            // 单身份的身份名称使用用户名称值替代 start
            this.fd.capacityVO.capacityName = this.fd.userVO.userName;
            // 单身份的身份名称使用用户名称值替代 end
            userService.save(this.fd)
              .then(rsp => {
                this.$alert('新增成功！', '提示', {
                  confirmButtonText: '确定',
                  type: 'success',
                  callback: action => {
                  }
                });
                this.closeNavTabAndTo({ name: 'singleUserManage', params: { isRefresh: true } }, true);
              })
              .catch(err => {
                console.error('用户新增出错！', err);
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            // 单身份不会创建新身份
            this.$alert('用户已存在！', '提示', {
              confirmButtonText: '确定',
              type: 'warning',
              callback: action => {
              }
            });
          }
        }
      });
    }
  }
};
</script>
